module.exports = __webpack_public_path__ + "img/32.c8343fe6.png";